import * as React from 'react';
import { Scrollbar, Button, icons, TableOfContents as TableOfContentsUI } from '@invertase/ui';

import Link from '../components/Link';

import { MdxTableOfContentsItem } from '../types/mdx';
import FeedbackForm from './FeedbackForm';

const { Heart, EditPencil } = icons;

interface Props {
  path?: string;
  contents: MdxTableOfContentsItem[];
}

function TableOfContents({ path, contents }: Props) {
  return (
    <aside className="sticky" style={{ top: '4rem' }}>
      <Scrollbar className="mt-16 overflow-y-auto" style={{ height: `calc(100vh - 8rem)` }}>
        <div className="pt-4 pb-16 pl-10 pr-2">
          <div className="mb-8 mr-1">
            {!!path && (
              <div className="mb-2">
                <Button
                  onClick={() =>
                    window.open(
                      `https://github.com/invertase/notifee/blob/main/docs-react-native/${path}`,
                      '_blank',
                    )
                  }
                  ghost
                  className="w-full"
                >
                  <EditPencil size={14} className="mr-2" />
                  Edit Page
                </Button>
              </div>
            )}
          </div>
          <div className="text-gray-500 uppercase tracking-wider font-bold text-base lg:text-xs tracking-wide">
            On this page
          </div>
          <TableOfContentsUI
            items={contents}
            renderLink={(url, text) => <Link to={url}>{text}</Link>}
          />
        </div>
      </Scrollbar>
    </aside>
  );
}

export default TableOfContents;
